export default [
  { name: 'Alabama', abbreviation: 'AL', timezone_id: 'America/New_York' },
  { name: 'Alaska', abbreviation: 'AK', timezone_id: 'America/Anchorage' },
  { name: 'Arizona', abbreviation: 'AZ', timezone_id: 'America/Phoenix' },
  { name: 'Arkansas', abbreviation: 'AR', timezone_id: 'America/Chicago' },
  { name: 'California', abbreviation: 'CA', timezone_id: 'America/Los_Angeles' },
  { name: 'Colorado', abbreviation: 'CO', timezone_id: 'America/Denver' },
  { name: 'Connecticut', abbreviation: 'CT', timezone_id: 'America/New_York' },
  { name: 'Delaware', abbreviation: 'DE', timezone_id: 'America/New_York' },
  { name: 'District Of Columbia', abbreviation: 'DC', timezone_id: 'America/New_York' },
  { name: 'Florida', abbreviation: 'FL', timezone_id: 'America/New_York' },
  { name: 'Georgia', abbreviation: 'GA', timezone_id: 'America/New_York' },
  { name: 'Hawaii', abbreviation: 'HI', timezone_id: 'America/Adak' },
  { name: 'Idaho', abbreviation: 'ID', timezone_id: 'America/Denver' },
  { name: 'Illinois', abbreviation: 'IL', timezone_id: 'America/Chicago' },
  { name: 'Indiana', abbreviation: 'IN', timezone_id: 'America/New_York' },
  { name: 'Iowa', abbreviation: 'IA', timezone_id: 'America/Chicago' },
  { name: 'Kansas', abbreviation: 'KS', timezone_id: 'America/Chicago' },
  { name: 'Kentucky', abbreviation: 'KY', timezone_id: 'America/New_York' },
  { name: 'Louisiana', abbreviation: 'LA', timezone_id: 'America/Chicago' },
  { name: 'Maine', abbreviation: 'ME', timezone_id: 'America/New_York' },
  { name: 'Maryland', abbreviation: 'MD', timezone_id: 'America/New_York' },
  { name: 'Massachusetts', abbreviation: 'MA', timezone_id: 'America/New_York' },
  { name: 'Michigan', abbreviation: 'MI', timezone_id: 'America/New_York' },
  { name: 'Minnesota', abbreviation: 'MN', timezone_id: 'America/Chicago' },
  { name: 'Mississippi', abbreviation: 'MS', timezone_id: 'America/Chicago' },
  { name: 'Missouri', abbreviation: 'MO', timezone_id: 'America/Chicago' },
  { name: 'Montana', abbreviation: 'MT', timezone_id: 'America/Denver' },
  { name: 'Nebraska', abbreviation: 'NE', timezone_id: 'America/Chicago' },
  { name: 'Nevada', abbreviation: 'NV', timezone_id: 'America/Denver' },
  { name: 'New Hampshire', abbreviation: 'NH', timezone_id: 'America/New_York' },
  { name: 'New Jersey', abbreviation: 'NJ', timezone_id: 'America/New_York' },
  { name: 'New Mexico', abbreviation: 'NM', timezone_id: 'America/Denver' },
  { name: 'New York', abbreviation: 'NY', timezone_id: 'America/New_York' },
  { name: 'North Carolina', abbreviation: 'NC', timezone_id: 'America/New_York' },
  { name: 'North Dakota', abbreviation: 'ND', timezone_id: 'America/Chicago' },
  { name: 'Ohio', abbreviation: 'OH', timezone_id: 'America/New_York' },
  { name: 'Oklahoma', abbreviation: 'OK', timezone_id: 'America/Chicago' },
  { name: 'Oregon', abbreviation: 'OR', timezone_id: 'America/Denver' },
  { name: 'Pennsylvania', abbreviation: 'PA', timezone_id: 'America/New_York' },
  { name: 'Puerto Rico', abbreviation: 'PR', timezone_id: 'America/Puerto_Rico' },
  { name: 'Rhode Island', abbreviation: 'RI', timezone_id: 'America/New_York' },
  { name: 'South Carolina', abbreviation: 'SC', timezone_id: 'America/New_York' },
  { name: 'South Dakota', abbreviation: 'SD', timezone_id: 'America/Chicago' },
  { name: 'Tennessee', abbreviation: 'TN', timezone_id: 'America/New_York' },
  { name: 'Texas', abbreviation: 'TX', timezone_id: 'America/Chicago' },
  { name: 'Utah', abbreviation: 'UT', timezone_id: 'America/Denver' },
  { name: 'Vermont', abbreviation: 'VT', timezone_id: 'America/New_York' },
  { name: 'Virginia', abbreviation: 'VA', timezone_id: 'America/New_York' },
  { name: 'Washington', abbreviation: 'WA', timezone_id: 'America/Los_Angeles' },
  { name: 'West Virginia', abbreviation: 'WV', timezone_id: 'America/New_York' },
  { name: 'Wisconsin', abbreviation: 'WI', timezone_id: 'America/Chicago' },
  { name: 'Wyoming', abbreviation: 'WY', timezone_id: 'America/Denver' }
];


// WEBPACK FOOTER //
// ./src/js/util/constants/states.js